import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';

import { sendPostMessage } from '../../../helpers/Mini';

const MiniHeaderButtons = ({ miniConfig }) => {
  if (!miniConfig.buttons || miniConfig.buttons.length === 0) {
    return null;
  }

  return (
    <>
      {miniConfig.buttons.map(button => (
        <Fragment key={button.id}>
          <NavItem>
            <NavLink
              key={button.id}
              id={button.id}
              tag="a"
              href={`#${button.id}`}
              onClick={(e) => {
                e.preventDefault();
                sendPostMessage(button.event);
              }}
            >
              <i className={`fal ${button.icon || 'question'}`} />
              {!button.iconOnly && (
                <span className="nav-link-title">
                  {button.title}
                </span>
              )}
            </NavLink>
          </NavItem>
          {button.iconOnly && (
            <UncontrolledTooltip fade={false} target={button.id} position="bottom" boundariesElement={`#${button.id}`}>
              {button.title}
            </UncontrolledTooltip>
          )}
        </Fragment>
      ))}
    </>
  );
};

const mapStateToProps = state => ({
  miniConfig: state.Mini.config,
});

MiniHeaderButtons.propTypes = {
  miniConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MiniHeaderButtons);
